import angular from 'angular';

class modalEmailInvitationCtrl {
    /*@ngInject*/
    constructor(PrincipalSvc, logger) {
        this.PrincipalSvc = PrincipalSvc;
        this.logger = logger;
    }

    $onInit() {
        this.principal = angular.copy(this.resolve.principal);
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html')
        };
        this.title = 'principal.email_template.title';
        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = false;
        this.manageDisplay('form');
    }

    importZip() {
        if (this.form.$valid) {
            this.manageDisplay('load');
            this.PrincipalSvc.importEmailTemplate(this.file, this.principal.detail.id, this.resolve.type).then(
                listUploadTemplate => {
                    this.manageDisplay('result');
                    var listUploadTemplateJson = this.buildJsonData(listUploadTemplate.data);
                    this.listUploadTemplate = listUploadTemplateJson;
                    this.title = 'principal.email_template.result_title';
                },
                (/*error*/) => {
                    this.file = null;
                    this.logger.error('error.import_templates');
                    this.manageDisplay('form');
                }
            );
        }
    }

    buildJsonData(data) {
        var dataResult = [];
        for (var i = 0; i < data.length; i++) {
            var element = {
                fileName: data[i],
                fileType: this.getFileNameTab(data[i])[0],
                fileLang: this.getFileNameTab(data[i])[1],
                fileNature: this.getFileNature(data[i])
            };
            dataResult.push(element);
        }
        return dataResult;
    }

    // Décomposer le nom d'un fichier
    getFileNameTab(fileName) {
        var reg = new RegExp('[_.-]+', 'g');
        var fileNameTab = fileName.split(reg);

        return fileNameTab;
    }

    // return 0 si le fichier est une image. 1 sinon
    getFileNature(fileName) {
        if (fileName.match(/\.(jpg|jpeg|png|gif)$/)) return 0;
        else return 1;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    ok() {
        this.modalInstance.close(false);
    }

    manageDisplay(step, type) {
        switch (step) {
            case 'form':
                this.displayForm = true;
                this.displayLoad = false;
                this.displayResult = false;
                break;
            case 'load':
                this.displayForm = false;
                this.displayLoad = true;
                this.displayResult = false;
                break;
            case 'result':
                this.title = 'principal.' + type + '.result.title';
                this.displayForm = false;
                this.displayLoad = false;
                this.displayResult = true;
                break;
        }
    }
}

angular.module('app.principal').component('modalEmailInvitation', {
    templateUrl: require('./modal-email-invitation.html'),
    controller: modalEmailInvitationCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<'
    }
});
